// extracted by mini-css-extract-plugin
export default {"card":"CardMinor_card__a000t","imgWrapper":"CardMinor_imgWrapper__ow+A2"};